import { useEffect } from "react";

export default function Modal({ open, onClose, title, children, size = "md", testId }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  const widths = { sm: "max-w-md", md: "max-w-lg", lg: "max-w-2xl", xl: "max-w-4xl" };

  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4 bg-black/40 backdrop-blur-sm animate-fade-up" onClick={onClose} data-testid={testId}>
      <div className={`bg-white rounded-xl shadow-xl w-full ${widths[size]} max-h-[90vh] overflow-y-auto`} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-[rgba(28,28,30,0.06)]">
          <h3 className="font-heading text-lg">{title}</h3>
          <button onClick={onClose} className="text-agri-ink-2 hover:text-agri-ink text-xl leading-none" data-testid="modal-close-btn">×</button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}

export const inputCls = "w-full border border-[rgba(28,28,30,0.18)] bg-white rounded-md px-3 py-2 text-sm text-agri-ink placeholder:text-agri-ink-2/60 transition-colors focus:outline-none focus:ring-2 focus:ring-agri-forest/25 focus:border-agri-forest disabled:bg-black/[0.03] disabled:text-agri-ink-2 disabled:cursor-not-allowed";
export const labelCls = "block mb-1.5 text-sm font-medium text-agri-ink";
// Append to inputCls when a field has an error (wins via !important).
export const inputErrCls = "!border-agri-danger focus:!border-agri-danger focus:!ring-agri-danger/30";
export function FieldError({ children }) {
  return children ? <p className="mt-1 text-xs text-agri-danger">{children}</p> : null;
}
export const btnPrimary = "bg-agri-forest hover:bg-agri-forest-dark text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-agri-forest/40 focus-visible:ring-offset-1 disabled:opacity-50 disabled:pointer-events-none";
export const btnAccent = "bg-agri-amber hover:bg-agri-amber-dark text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-agri-amber/40 focus-visible:ring-offset-1 disabled:opacity-50 disabled:pointer-events-none";
export const btnGhost = "text-sm font-medium px-3 py-2 rounded-lg text-agri-ink-2 hover:bg-black/5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-agri-forest/30";
export const btnOutline = "border border-[rgba(28,28,30,0.15)] text-agri-ink hover:bg-black/5 text-sm font-medium px-4 py-2 rounded-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-agri-forest/30 disabled:opacity-50 disabled:pointer-events-none";
